<div class="full-signup d-flex align-items-stretch">
  <div class="signup-col">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 form-col">
          <!-- Signup -->
          <img class="buk-logo clickable" src="/assets/logo-a.png" alt="" rel="canonical" routerLink="/" />
          <h3 class="mb-1">{{ 'SHARED.signup2.registerBusinessTitle' | translate }}</h3>
          <p class="mb-4">{{ 'SHARED.signup2.registerAccountSubtitle' | translate }}</p>

          <div class="mb-2">
            <app-facebook-auth (socialError)="socialError()" type="{{ 'SHARED.login.ctaLogin' | translate }}"></app-facebook-auth>
          </div>
          <div class="mb-4">
            <app-google-auth  (socialError)="socialError()" type="signup" [showPrompt]="false" [showBotton]="true"></app-google-auth>
          </div>

          <div class="or-email">
            <p>{{ 'SHARED.signup2.orUseEmail' | translate }}</p>
          </div>

          <form [formGroup]="form" (ngSubmit)="submit()" *ngIf="form">

            <app-text-input
              inputClasses=""
              formControlName="firstName"
              [submitAttempted]="submitAttempted"
              placeholder="{{ 'SHARED.signup.yourName' | translate }}"
              inputType="text"
              invalidMsg="{{ 'SHARED.signup.writeYourName' | translate }}"
            ></app-text-input>
            <app-text-input
              inputClasses=""
              formControlName="email"
              [submitAttempted]="submitAttempted"
              placeholder="{{ 'GENERAL.email' | translate }}"
              inputType="email"
              invalidMsg="{{ 'SHARED.signup.writeYourEmail' | translate }}"
            ></app-text-input>
    
            <app-text-input
              inputClasses=""
              formControlName="password"
              [submitAttempted]="submitAttempted"
              placeholder="{{ 'GENERAL.password' | translate }}"
              inputType="password"
              invalidMsg="{{ 'SHARED.signup.writePassword' | translate }}"
            ></app-text-input>
    
            <!-- error -->
            <app-alert [msg]="errorMsg" type="danger"></app-alert>
            <!-- submit -->
            <app-submit-btn
              inputClasses="w100 btn-lg"
              [loading]="loading"
              [hasError]="errorMsg"
              btnCopy="{{ 'GENERAL.continue' | translate }}"
            ></app-submit-btn>
          </form>

          <p class="footer-links">
            {{ 'SHARED.signup.alreadyHaveAnAccount' | translate }} <a rel="canonical" routerLink="/login">{{ 'SHARED.signup.loginHere' | translate }}</a>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="signup-col bg-img d-flex align-items-bottom">
    <div class="testimonial d-flex align-items-center">
      <div>
        <div class="test-content d-flex align-items-top">
          <div class="avatar"></div>
          <div class="quote">
            <h4>
              {{ 'SIGNUP.testimonial.quote' | translate }}
            </h4>
            <p class="name">{{ 'SIGNUP.testimonial.author' | translate }}</p>
          </div>
        </div>

        <div class="list-benefits">
          <div class="row" data-nosnippet>
            <div class="col-12">
              <h3>{{ 'SIGNUP.testimonial.benefitsTitle' | translate }}</h3>
            </div>
            <div class="col-md-6">
              <p class="d-flex align-items-center">
                <i class="material-icons icon">check</i> {{ 'SIGNUP.testimonial.benefitsList.0' | translate }}
              </p>
            </div>
            <div class="col-md-6">
              <p><i class="material-icons icon">check</i> {{ 'SIGNUP.testimonial.benefitsList.1' | translate }}</p>
            </div>
            <div class="col-md-6">
              <p><i class="material-icons icon">check</i> {{ 'SIGNUP.testimonial.benefitsList.2' | translate }}</p>
            </div>
            <div class="col-md-6">
              <p><i class="material-icons icon">check</i> {{ 'SIGNUP.testimonial.benefitsList.3' | translate }}</p>
            </div>
            <div class="col-md-6">
              <p><i class="material-icons icon">check</i> {{ 'SIGNUP.testimonial.benefitsList.4' | translate }}</p>
            </div>
            <div class="col-md-6">
              <p><i class="material-icons icon">check</i> {{ 'SIGNUP.testimonial.benefitsList.5' | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-whatsapp-cta></app-whatsapp-cta>
